import { render, staticRenderFns } from "./HotelAdd.vue?vue&type=template&id=08753e96"
import script from "./HotelAdd.vue?vue&type=script&lang=js"
export * from "./HotelAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports